import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { styled } from '@mui/material';

export const DetailsArrow = styled(ExpandMoreIcon)(({ theme }) => ({
  color: theme.palette.text.disabled,
  marginRight: theme.spacing(-1),
  transform: 'rotate(-90deg)',
}));
